// src/components/shared/AudioPlayer.tsx
// Minimal audio player with download button. Uses native HTML5 <audio>.

import { Download } from 'lucide-react';

interface Props {
  src: string;
  label?: string;
  className?: string;
}

export function AudioPlayer({ src, label, className = '' }: Props) {
  return (
    <div className={`flex items-center gap-3 rounded-xl bg-muted/50 border border-border p-3 ${className}`}>
      <audio controls preload="metadata" className="flex-1 h-8 min-w-0" src={src}>
        Tu navegador no soporta audio.
      </audio>
      {label && <span className="text-xs text-muted-foreground shrink-0">{label}</span>}
      <a
        href={src}
        download
        target="_blank"
        rel="noopener noreferrer"
        className="p-1.5 rounded-lg text-muted-foreground hover:text-foreground/80 hover:bg-muted transition-colors shrink-0"
        title="Descargar"
      >
        <Download size={14} />
      </a>
    </div>
  );
}
